<template>
  <div class="tabs-langue" :class="$mq">
    <div class="tab-langue" :class="[fr]" @click="traduction_fr">
      {{ languages.fr.title }}
    </div>
    <v-divider vertical></v-divider>
    <div class="tab-langue" :class="[en]" @click="traduction_en">
      {{ languages.en.title }}
    </div>
  </div>
</template>

<script>
import i18n from "@/i18n"

export default {
  name: "tabs",

  data() {
    return {
      fr: 'focus',
      en: '',
      languages: {
        fr: {
          name: "fr",
          title: "Français",
          active: true,
        },
        en: {
          name: "en",
          title: "English",
          active: false,
        }
      },
    }
  },

  methods: {
    traduction_en() {
      i18n.locale = this.languages.en.name
      this.en = 'focus'
      this.fr = ''
    },

    traduction_fr() {
      i18n.locale = this.languages.fr.name
      this.en = ''
      this.fr = 'focus'
    },
  }
}
</script>

<style lang="scss">
@import "../../utilities/variables";

.tabs-langue {
  font-family: Unistra A !important;
  font-size: 1.2em;
}

.tabs-langue.smartphone {
  display: flex;
  justify-content: center;
  margin: 20px 0;
}

.tab-langue {
  margin: 0 10px;
  padding: 10px;
  border: solid 1px $button-color-blue;
  color: $text-color;
  &:hover {
    background-color: $button-color-blue;
    color: $text-button-color;
  }
  &:active {
    background-color: $button-color;
    color: $text-color;
  }
}

.focus {
  background-color: $button-color;
  color: $text-color;
}
</style>
